import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import MobileHeader from "../../components/MobileHeader";
import BottomNav from "../../components/BottomNav";
import { Badge, Button, Card, Input, Label } from "../../components/ui-kit";

export default function DriverSupport() {
  const { user } = useAuth();
  const workerRole = user?.role === "courier" ? "courier" : "driver";
  const [tickets, setTickets] = useState([]);
  const [form, setForm] = useState({ title: "", message: "", ride_id: "", category: "driver" });
  const load = () => api.get("/disputes/me").then(({ data }) => setTickets(data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try {
      await api.post("/disputes", {
        ride_id: form.ride_id || null,
        category: form.category,
        title: form.title,
        message: form.message,
      });
      toast.success("Demande envoyee au support");
      setForm({ title: "", message: "", ride_id: "", category: "driver" });
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="phone-frame phone-scroll-safe bg-premium-grad">
      <MobileHeader title="Support chauffeur" />
      <div className="space-y-4 px-4 pt-2">
        <Card className="space-y-3 p-4">
          <h1 className="font-heading text-2xl font-bold">Contacter Nexora</h1>
          <div><Label>Sujet</Label><Input value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} /></div>
          <div><Label>ID course optionnel</Label><Input value={form.ride_id} onChange={(e) => setForm((f) => ({ ...f, ride_id: e.target.value }))} /></div>
          <div>
            <Label>Categorie</Label>
            <select value={form.category} onChange={(e) => setForm((f) => ({ ...f, category: e.target.value }))} className="w-full rounded-xl border border-white/10 bg-background px-4 py-3">
              {["driver", "ride", "payment", "safety", "refund", "other"].map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
          </div>
          <div>
            <Label>Message</Label>
            <textarea value={form.message} onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))} rows={5} className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-foreground" />
          </div>
          <Button onClick={submit} className="w-full">Envoyer au support</Button>
        </Card>

        <Card className="p-0">
          <div className="border-b border-white/10 p-4 font-heading text-lg font-bold">Historique support</div>
          <div className="divide-y divide-white/5">
            {tickets.length === 0 && <div className="p-5 text-center text-xs text-muted-foreground">Aucun ticket</div>}
            {tickets.map((ticket) => (
              <div key={ticket.id} className="p-3">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="font-bold">{ticket.title}</div>
                    <div className="mt-1 text-xs text-muted-foreground">{ticket.message}</div>
                    {ticket.admin_note && <div className="mt-2 rounded-xl bg-white/5 p-2 text-xs text-primary">{ticket.admin_note}</div>}
                  </div>
                  <Badge tone={ticket.status === "OPEN" ? "warning" : ticket.status === "RESOLVED" ? "success" : "primary"}>{ticket.status}</Badge>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
      <BottomNav role={workerRole} />
    </div>
  );
}
